var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDialysisSidebarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "url(#pattern0_5470_16527)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5470_16527",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5470_16527",
    transform: "matrix(0.0138889 0 0 0.0104167 -0.166667 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5470_16527",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC6UlEQVR4nO2dyWoVURRF18AGxw5sB0Z/wojY/YMOdKaTiEbs/iQDTdDPEOxn9oISMToSHAVjJskLxFGOFNxAkKqXet7Ky9n3nQUHAilu9j67+qqbgiAIgiAIgiAIgiAIgiDonrPADPANWAHMWa0kbdPAGQriGPDCQYNtwHoGjCHOCWDRQTPtP+s3MI4oR4AFB020zFpMW7Eczx00zzqql4hxzkHTrOOSOjDPNJhYBW4C+/HHAeBW0lin/T5CfG8wUTXfO7cbtM8hRK/BhMc1/1/2NWhfRoim/agKJq5f3oCJ65c3YOL65Q2YuH55AyauX96AieuXN2Di+uUNmLh+eQMmrl/egInrlzdg4vrlDZi4/kYDCjfjDpYcQHWr1zt3Sw5gNYVQPfzwRqXpDvCn5ADUS4btbpRFAGWWDNvdKIsAyiwZmgxMAV/6PLS3baxe0jZVcgAqmLh+eQMmrl/egInrH5qBC8D5LRg3AmjB3vT6+0L6uUsigBY83DDuA0YogDbittrASWBtw7hrHb8+7sGjW3E7gNmasWfT70rw6FrclT7jXy7Eo1txu4Affcb/Cezu4O9EAA1M9hl7va6TTwRQwx5gvkUA82nZHCKAGi61aP56XSSPCKCGRwMEUC2bQwRQw68BAqiWzSECqGGQZwhL5BEB1PBugADekEcEUMONAQLIPRWNAGqoLrA+t2j+p3TBlkME0MDhTUKomn+IfCKATbaEybSf76V6nXY7uWu+F4+64kbBo2txo+DRtbhR8OjxpSpzUrkXgK1468CoOa3qZGDLuebAqDmtiWEEUJ3qfXRg1pzVe2AnQ5zO88GBaXPU/KFPu6rSvgq8GtEDcy95nxjmmh8EQSDAcoEz5Zco4B+3Ks+Un0OI6QJnyt9D7GsZVlidQoynDppmHdVjBCnpAw5HEWU8fQbERGsBOI44Y6K7oydpKy6G0+kjCHNO7x31gK/pbEfugBsEQRAEQRAEQRAEQRDgnr83JKax9BFClQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialysisSidebarIcon);
export default __webpack_public_path__ + "static/media/dialysisSidebarIcon.fcb2574f9db3d4923e9133f89e01d039.svg";
export { ForwardRef as ReactComponent };